

import { LayoutConfig } from '@spartacus/storefront';

export const CustomLayoutConfig: LayoutConfig = {
  layoutSlots: {
    header: {
      slots: ['SiteLogo'],
    },
    KBSHomePageTemplate: {
      slots: ['BodyContent'],
    },
    footer: {
      slots: ['Footer']
    }
  },
};



